import React from "react";
import { Icon } from "@iconify/react";

const Step_01_Start = ({ handleNextStep }) => {
  return (
    <div className="w-full mx-auto bg-white rounded-xl   flex flex-col items-center space-y-4">
      {/* Office building icon */}
      <div className="relative">
        <span className="flex items-center justify-center w-16 h-16 rounded-full bg-teal-100">
          <Icon
            icon="mdi:office-building"
            width="32"
            height="32"
            className="text-teal-600"
          />
        </span>
        {/* Sparkle */}
        <span className="absolute -top-2 -right-2">
          <Icon
            icon="mdi:sparkle"
            width="22"
            height="22"
            className="text-teal-400"
          />
        </span>
      </div>
      <h2 className="text-xl font-semibold text-teal-700 text-center">
        AI Office Design Assistant
      </h2>
      <div className="text-gray-700 text-sm text-center">
        Hey there!{" "}
        <span role="img" aria-label="wave">
          👋
        </span>{" "}
        I'm your AI design companion. Let's create an amazing office space
        together! I'll guide you through everything step by step.
      </div>
      {/* Buttons */}
      <div className="flex flex-col gap-2 w-full mt-2">
        <button
          onClick={() => handleNextStep()}
          className="w-full py-2 bg-teal-500 hover:bg-teal-600 text-white font-medium rounded-lg flex items-center justify-center gap-2 transition"
        >
          Start Designing
          <Icon icon="mdi:sparkle" width="18" height="18" />
        </button>
        <button className="w-full py-2 bg-teal-50 hover:bg-teal-100 text-teal-700 rounded-lg font-medium flex items-center justify-center gap-2 border border-teal-100 transition">
          Just Exploring
          <Icon icon="mdi:eye-outline" width="18" height="18" />
        </button>
      </div>
    </div>
  );
};

export default Step_01_Start;
